import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TeamBox = ({ className = '', limit = null }) => {
  const { t } = useTranslation();
  const teams = t('sections.teamBox.teams', { returnObjects: true, defaultValue: [
    { name: 'Michael Johnson', img: 'assets/img/team/team_2_1.jpg', desig: 'UI/UX Designer' },
    { name: 'Sarah Rahman', img: 'assets/img/team/team_2_2.jpg', desig: 'UI/UX Designer' },
    { name: 'Justin Kingdony', img: 'assets/img/team/team_2_3.jpg', desig: 'UI/UX Designer' }
  ] });

  const displayedTeams = limit ? teams.slice(0, limit) : teams;

  return (
    <>
      {displayedTeams.map((team, index) => (
        <div className={className} key={index}>
          <div className="ot-team team-card2">
            <div className="box-img">
              <img src={team.img} alt={team.name} />
            </div>
            <div className="box-content">
              <h3 className="box-title">
                <Link to="/team-details">{team.name}</Link>
              </h3>
              <span className="box-desig">{team.desig}</span>
              <div className="ot-social style3">
                <a target="_blank" href="https://facebook.com/" rel="noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a target="_blank" href="https://twitter.com/" rel="noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a target="_blank" href="https://linkedin.com/" rel="noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a target="_blank" href="https://instagram.com/" rel="noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default TeamBox;